import { motion } from "framer-motion" ;
import { ArrowRight, Star, TrendingUp, Target, Zap } from "lucide-react";
import image1 from '@/assets/VisibilityAssets/image2.jpg'
import image2 from '@/assets/VisibilityAssets/image3.jpg'
import image3 from '@/assets/VisibilityAssets/image1.jpg'

const Ads = () => {
  const testimonials = [
    {
      id: 1,
      title: "Facebook Ad Optimization",
      description: "In the first week of the Facebook ad, this client didn't get any website purchases, so we lowered the ad spend and helped secure a 65% increase in website purchases.",
      metrics: [
        { label: "Website Purchases", value: "26" },
        { label: "Cost per purchase", value: "₦11,715.89" },
        { label: "Ad Spend", value: "₦304,613.26" }
      ],
      beforeAfter: [
        { label: "Before", amount: "₦54,988.45" },
        { label: "After", amount: "₦11,715.89" }
      ],
      image: image1
    },
    {
      id: 2,
      title: "Social Media Transformation",
      description: "Sometimes, what you need is a little touch... Most times, what you need is our expertise. We transformed social media presence with strategic content optimization.",
      metrics: [
        { label: "Engagement Rate", value: "+142%" },
        { label: "Follower Growth", value: "+89%" },
        { label: "Conversion Rate", value: "+67%" }
      ],
      image: image2
    },
    {
      id: 3,
      title: "Newbie Client Success",
      description: "After applying our growth strategy in less than a week! This client wanted to increase their reach and customer engagement.",
      metrics: [
        { label: "Reach Increase", value: "13,986" },
        { label: "Engagement", value: "9,473" },
        { label: "Video Views", value: "42h 22m 3s" }
      ],
      beforeAfter: [
        { label: "Before", views: "89" },
        { label: "After", views: "18,310" }
      ],
      image: image3
    }
      
  ];

  return (
    <div className=" pt-10 min-h-screen bg-white">
      { /* Hero Section */}
      <div className="bg-gradient-to-r from-blue-50 to-indigo-50 py-10 px-6">
        <div className="max-w-7xl mx-auto">
          <h1 className="text-4xl md:text-5xl font-bold text-gray-800 mb-4">
            Proven Results That Speak for Themselves
          </h1>
          <p className="text-xl text-gray-600 max-w-3xl">
            See how our digital marketing strategies have transformed businesses across industries with measurable results.
          </p>
        </div>
      </div>

      {/* Testimonials Section */}
      <div className="py-10 px-6">
        <div className="max-w-7xl mx-auto">
          <div className="grid grid-cols-1  gap-6">
            {testimonials.map((testimonial, index) => (
              <motion.div
                key={testimonial.id}
                initial={{ opacity: 0, y: 50 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ delay: index * 0.1, duration: 0.5 }}
                className="bg-white rounded-xl shadow-lg p-4 border border-gray-100 hover:shadow-xl transition-shadow duration-300"
              >
                <div className="flex items-center mb-4">
                  <div className="w-12 h-12 bg-blue-100 rounded-full flex items-center justify-center mr-4">
                    {index === 0 && <Target className="w-6 h-6 text-blue-600" />}
                    {index === 1 && <Zap className="w-6 h-6 text-blue-600" />}
                    {index === 2 && <TrendingUp className="w-6 h-6 text-blue-600" />}
                  </div>
                  <h3 className="text-2xl font-bold text-gray-800">{testimonial.title}</h3>
                </div>
                <div className="grid sm:grid-cols-2 grid-cols-1 gap-2 ">
                <div>
                <p className="text-gray-600 mb-6 leading-relaxed">{testimonial.description}</p>
                
                <div className="mb-4">
                  <h4 className="font-semibold text-gray-800 mb-2">Key Metrics:</h4>
                  <div className="grid grid-cols-2 gap-3">
                    {testimonial.metrics.map((metric, i) => (
                      <div key={i} className="bg-blue-50 rounded-lg p-3">
                        <div className="text-sm text-gray-500">{metric.label}</div>
                        <div className="text-lg font-bold text-blue-700">{metric.value}</div>
                      </div>
                    ))}
                  </div>
                </div>
                
                {testimonial.beforeAfter && (
                  <div className="bg-gray-50 rounded-lg p-4">
                    <h4 className="font-semibold text-gray-800 mb-2">Before & After:</h4>
                    <div className="flex justify-between items-center">
                      {testimonial.beforeAfter.map((item, i) => (
                        <div key={i} className="text-center">
                          <div className="text-sm font-medium text-gray-600">{item.label}</div>
                          <div className="text-xl font-bold text-gray-800">
                            {item.amount || item.views}
                          </div>
                        </div>
                      ))}
                      <ArrowRight className="text-gray-400" />
                    </div>
                  </div>
                )}
                </div>
                <div>
                  <img
                    src={testimonial.image}
                    alt={`Chart for ${testimonial.title}`}
                    className="w-full h-auto rounded-lg mt-6"
                  />
                </div>
                </div>
                <div className="mt-6 flex items-center">
                  {[1, 2, 3, 4, 5].map((star) => (
                    <Star key={star} className="w-5 h-5 text-yellow-400 fill-current" />
                  ))}
                  <span className="ml-2 text-sm text-gray-500">5.0/5</span>
                </div>
              </motion.div>
            ))}
          </div>
        </div>
      </div>

      
    </div>
  );
};

export default Ads;